import React, { useEffect, useState } from "react";

const SectionHeader = (props) => {
  const [header, setHeader] = useState("");

  useEffect(() => {
    if (props.match.url === "/" || props.match.url === "/dashboard") {
      setHeader("Dashboard");
    } else if (
      props.match.url === "/passwordchange" ||
      props.match.url === "/changepassword"
    ) {
      setHeader("Change Password");
    } else if (props.match.url === "/profile") {
      setHeader("Profile");
    } else if (
      props.match.url === "/colors" ||
      props.match.url === "/fonts" ||
      props.match.url === "/branding"
    ) {
      setHeader("Layout Center");
    } else if (props.match.url === "/vcms") {
      setHeader("Content Center");
    } else if (props.match.url === "/videodetails") {
      setHeader("Customize Media");
    } else if (
      props.match.url === "/analyticreport" ||
      props.match.url === "/videoreport" ||
      props.match.url === "/subscriptionreport"
    ) {
      setHeader("Reports");
    } else if (
      props.match.url === "/log" ||
      props.match.url === "/users" ||
      props.match.url === "/notification"
    ) {
      setHeader("Admin and Security");
    } else {
      setHeader("Control Center");
    }
  }, [props.match.url]);

  return (
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1 className="m-0">{header}</h1>
          </div>
          {/* /.col */}
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item"> </li>
            </ol>
          </div>
          {/* /.col */}
        </div>
        {/* /.row */}
      </div>
    </div>
  );
};

export default SectionHeader;
